import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/$locale/_authenticated/admin/settings')({
  component: AdminSettingsLayout,
});

function AdminSettingsLayout() {
  return <Outlet />;
}
